/** Hub's limit for one file (the server's MAX_ATTACHMENT_BYTES) */
export const MAX_FILE_BYTES = 20 * 1024 * 1024
/** What the file picker offers: what Hub takes (src/attachments.ts) */
export const ACCEPTED_FILES = "image/*,application/pdf,text/plain,text/csv,.txt,.csv,.docx,.xlsx"

const SHRINKABLE = /^image\/(jpeg|png|webp)$/
const SHRINK_OVER = 1.5 * 1024 * 1024
const LONG_SIDE = 2048

/**
 * A phone's photo made smaller before it's sent: at most 2048 px on the long side, as JPEG. Small
 * pictures, and anything else, go as they are.
 */
export async function shrinkPicture(file: File): Promise<{ blob: Blob; name: string }> {
  if (!SHRINKABLE.test(file.type) || file.size <= SHRINK_OVER || typeof createImageBitmap !== "function") {
    return { blob: file, name: file.name }
  }
  try {
    // Turned the way the camera held it (EXIF), as browsers show it
    const bitmap = await createImageBitmap(file)
    const scale = Math.min(1, LONG_SIDE / Math.max(bitmap.width, bitmap.height))
    const canvas = document.createElement("canvas")
    canvas.width = Math.round(bitmap.width * scale)
    canvas.height = Math.round(bitmap.height * scale)
    const ctx = canvas.getContext("2d")!
    // A transparent screenshot gets a white background, not black
    ctx.fillStyle = "#fff"
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
    bitmap.close()
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.85))
    if (!blob || blob.size >= file.size) return { blob: file, name: file.name }
    return { blob, name: file.name.replace(/\.[^.]*$/, "") + ".jpg" }
  } catch {
    return { blob: file, name: file.name }
  }
}
